import { AppState } from 'services/types';
import {
    SprayProductUnits,
    SprayProductPerUnitType
} from 'services/sprayEvents/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectUnitTypeFieldValue } from 'services/unitTypes/selectors';
import { OwnProps } from './index';

const selectUnits = (state: AppState, props: OwnProps): SprayProductUnits =>
    props.units;

const selectPerUnitType = (
    state: AppState,
    props: OwnProps
): SprayProductPerUnitType => props.perUnitType;

const selectRate = createDeepEqualSelector(
    selectUnits,
    makeSelectUnitTypeFieldValue('name'),
    selectPerUnitType,
    (units, unitTypeName, perUnitType) =>
        `${units} ${unitTypeName}/${perUnitType}`
);

const makeSelectRate = (): typeof selectRate => selectRate;

export { selectUnits, makeSelectRate };
